import { Component, Input, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { createConsoleLogger } from 'configcat-js';
import { AccountService } from 'src/app/services/user/account.service';
import { UiService } from 'src/app/services/ui.service';

@Component({
  selector: 'local-voucher-modal',
  templateUrl: './local-voucher-modal.component.html',
  styleUrls: ['./local-voucher-modal.component.scss'],
})
export class LocalVoucherModalComponent implements OnInit {
  @Input() vouchersInfo: any;
  @Input() subscribedTier: any;
  @Input() serviceType: string;
  @Input() totalCount: number;
  public totalVouchers: number;
  public copiedStates: boolean;
  public myAngularxQrCode: string;
  public qrCodeDownloadLink: SafeUrl = '';
  public userInfo: any;

  constructor(
    private modalController: ModalController,
    private accountService: AccountService,
    private uiService: UiService
  ) {}

  ngOnInit() {
    this.totalVouchers = this.vouchersInfo.length;
    this.copiedStates = false;
    this.myAngularxQrCode = this.vouchersInfo?.[0]?.code;
    this.userInfo = this.accountService?.userInfo;
  }

  closeModal() {
    this.modalController.dismiss();
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };
    const formatter = new Intl.DateTimeFormat('en-GB', options);
    const formattedDate = formatter.format(date);
    return formattedDate;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.copiedStates = true;
      this.uiService.presentToast('Copied to clipboard');
      setTimeout(() => {
        this.copiedStates = false;
      }, 2000);
    });
  }
}
